import { render, staticRenderFns } from "./UpsertDisbursement.vue?vue&type=template&id=33bb7eb4"
import script from "./UpsertDisbursement.vue?vue&type=script&lang=js"
export * from "./UpsertDisbursement.vue?vue&type=script&lang=js"
import style0 from "./UpsertDisbursement.vue?vue&type=style&index=0&id=33bb7eb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports